import {Locale} from "next-intl";
import {SettingsNavigationProperty} from "@pata/settings";
import {getLocale, getTranslations} from "next-intl/server";

export default async function fetchMainMenu(): Promise<SettingsNavigationProperty[]> {
    const locale: Locale = await getLocale()
    const t = await getTranslations({ locale, namespace: 'Navigation'})
    
    return [
        { name: t('wood-sawmill'), path: "/wood-sawmill", htmlId: 29 },
        { name: t('logging'), path: "/logging", htmlId: 30 },
        { name: t('forest-management'), path: "/forest-management", htmlId: 31 },
        { name: t('about-us#vakances'), path: "/about-us#vakances", htmlId: 445 },
    ]
}